/**
 * tradingSession.ts
 * Display label constants for trading session identity and status.
 *
 * Provides:
 * - Session type display labels (live, paper, observation, replay)
 * - Session status display labels (user-facing phase names)
 *
 * @see types/transient/SessionDraft.ts — source types for sessionType and status
 *
 * ARCHITECTURAL CONSTRAINTS:
 * - Zero cross-domain imports (only `import type` from `types/`)
 * - No side effects, pure data only
 * - All exports use `as const satisfies` for compile-time type safety
 */

import type { SessionDraft } from '@/types/transient/SessionDraft';

/** Display labels for session types */
export const SESSION_TYPE_LABELS = {
  'live': 'Live',
  'paper': 'Paper',
  'observation': 'Observation',
  'replay': 'Replay',
} as const satisfies Readonly<Record<SessionDraft['sessionType'], string>>;

/** User-facing display labels for session status phases */
export const STATUS_LABELS = {
  'pre-trading': 'Preparation',
  'live': 'Trading',
  'post-trading': 'Review',
  'review': 'Approval',
  'shelved': 'Shelved',
} as const satisfies Readonly<Record<SessionDraft['status'], string>>;
